import React, { FC } from 'react';
import {
  Modal,
  type ModalProps,
} from '@johnlewispartnership/wtr-ingredients/ingredients/Modal/index.js';
import { useCommonModal } from './context';

export const CommonModal: FC = () => {
  const { state, closeModal } = useCommonModal();

  const onCloseHandler: ModalProps['handleModalClose'] = event => {
    if (state.handleModalClose) state.handleModalClose(event);
    closeModal(event);
  };

  return <Modal {...state} handleModalClose={onCloseHandler} />;
};
